import moment from 'moment';

export default {
  customSelectionEdit(time, format) {
    return moment(time * 1000).utc().format(format || 'YYYY-MM-DD*HH:mm:ss');
  },
};
